import { date } from "yup";

export const formatForBackend = (dateString?: string | number) => {
  if (!dateString || typeof dateString !== "string") return "";

  const [day, month, year] = dateString.split("/");

  return `${year}-${month}-${day}`;
};
//"0001-01-01T00:00:00"
//2023-10-02T00:00:00 -> 2023 10  02T00:00:00 -> 02T00:00:00/10/2023 = 02T00:00:00/10/2023
// Convert YYYY-MM-DD -> DD/MM/YYYY (for backend)
export const formatForInput = (dateString: any) => {
  if (!dateString) return "";
  if (dateString == "0001-01-01T00:00:00") return "";
  if (dateString.includes("T")) {
    dateString = dateString.split("T")[0];
  }

  if (typeof dateString !== "string" || !dateString.includes("-")) {
    return dateString;
  }

  const [year, month, day] = dateString.split("-");

  return `${day}/${month}/${year}`;
};
